import { Publisher, Context } from '@amzn/katal-metrics';
import KatalMetricsDriverSushi from '@amzn/katal-metrics-driver-sushi';
import { getCurrentStage } from '../utilities';

class MetricsPublisher {
  constructor() {
    this.initialMetricsPublisher = this.makePublisher();
    this.actionPublisher = this.initialMetricsPublisher.newChildActionPublisherForMethod("defaultPublisher");
  }

  makePublisher = () => {
    const stage = getCurrentStage() === 'PROD' ? 'Prod' : 'Alpha';
    const metricsErrorHandler = (err) => {
      console.error(err);
    };
    const metricsDriver = new KatalMetricsDriverSushi.Builder()
      .withDomainRealm('prod', 'USAmazon')
      .withErrorHandler(metricsErrorHandler)
      .build();
    const initialMetricsContext = new Context.Builder()
      .withSite('Phoenix.' + stage)
      .withServiceName('Analytics')
      .build();
    return new Publisher(
      metricsDriver, metricsErrorHandler, initialMetricsContext,
    );
  };

  forMethod(methodName) {
    this.actionPublisher = this.initialMetricsPublisher.newChildActionPublisherForMethod(methodName);
    return this;
  }

  publishString(id, value) {
    this.actionPublisher.publishString(id, value);
    return this;
  }

  publishCounter(value) {
    this.actionPublisher.publishCounterMonitor('clicks', value);
    return this;
  }

  publishTimer(value) {
    this.actionPublisher.publishTimerMonitor('responseTime', value);
    return this;
  }
}
const metricsPublisher = new MetricsPublisher();

/**
  Usage:
  metricsPublisher.forMethod(name) <- Mandatory
                  .publishTimer(time) <- Optional
                  .publishCounter(count) <- Optional
                  .publishString(id, info); <- Optional
  */
export default metricsPublisher;


// WEBPACK FOOTER //
// ./src/utils/metrics.js